import { Box } from "@mui/material";
import { LoadingSpinner } from "@src/appV2/redesign/system/ui-components";

export function PaymentsListLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        height: "150px",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
      data-testid="payments-list-loader"
    >
      <LoadingSpinner size="large" />
    </Box>
  );
}
